.dateRangePickerWrapper {
  display: none;
}

.tagRow {
  margin-left: -11px;
}

.tag {
  margin: 4px;
  width: fit-content !important;
}
